import { render, staticRenderFns } from "./Club.vue?vue&type=template&id=708d28ce&scoped=true"
import script from "./Club.vue?vue&type=script&lang=js"
export * from "./Club.vue?vue&type=script&lang=js"
import style0 from "./Club.vue?vue&type=style&index=0&id=708d28ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d28ce",
  null
  
)

export default component.exports